import React from "react";
import {
    createBrowserRouter,
    RouterProvider,
    Navigate,
} from "react-router-dom";

import Gems from "./pages/gems";
import Four0Four from "./pages/404";

import "./App.css";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Navigate to="/gems" />,
    },
    {
        path: "/gems",
        children: [
            {
                path: "/gems",
                element: <Gems />,
            },
        ],
    },
    {
        path: "*",
        element: <Navigate to="/gems" />,
    },
]);

const App = () => {
    return (
        <RouterProvider router={router} />
    );
};

export default App;
